export default "__VITE_ASSET__rhFw_5Ij__"